const MS_PER_DAY = 86_400_000;

const toUtcDayNumber = (value: Date): number =>
  Math.floor(
    Date.UTC(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate()) /
      MS_PER_DAY
  );

const parseDate = (value: string | Date): Date | null => {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const hasReadyDatePassed = (
  availableDate: string | Date | null | undefined,
  now: Date = new Date()
): boolean => {
  if (!availableDate) return false;
  const date = parseDate(availableDate);
  if (!date) return false;
  return toUtcDayNumber(date) <= toUtcDayNumber(now);
};

export const isListingAvailable = (
  isAvailableNow: boolean | null | undefined,
  availableDate: string | Date | null | undefined,
  now: Date = new Date()
): boolean => Boolean(isAvailableNow) || hasReadyDatePassed(availableDate, now);
